// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/user-list';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;


export const getAppDefaultPath = (user) => {
  if (!user || !user.roles) return '/login';

  if (user.roles.includes('patient')) {
    return '/user-list';
  }

  if (user.roles.includes('admin') || user.roles.includes('superuser')) {
    return '/admin/dashboard';
  }
  if (user.roles.includes('doctor')) {
    return '/appointments/appointment-list';
  }
  if (user.roles.includes('nurse')) {
    return '/appointments/appointment-list';
  }
  if (user.roles.includes('optometrist')) {
    return '/appointments/appointment-list';
  }
  if (user.roles.includes('receptionist')) {
    return '/reception/patient-list';
  }
  if (user.roles.includes('pharmacy_store_manager')) {
    return '/medicine-list';
  }
  if (user.roles.includes('account_manager')) {
    return '/account/daily-cash-collection';
  }
  if (user.roles.includes('it_technician')) {
    return '/user-list';
  }
  if (user.roles.includes('lab_billing')) {
    return '/invoice/lab-invoice';
  }
  if (user.roles.includes('lab_technician')) {
    return '/labs/lab-test-list';
  }
  if (user.roles.includes('pharmacy_biller')) {
    return '/invoice/pharmacy-invoice';
  }

  return '/dashboard';
};

export let SimpleLayoutType;

(function (SimpleLayoutType) {
  SimpleLayoutType['SIMPLE'] = 'simple';
  SimpleLayoutType['LANDING'] = 'landing';
})(SimpleLayoutType || (SimpleLayoutType = {}));

export let ThemeMode;

(function (ThemeMode) {
  ThemeMode['LIGHT'] = 'light';
  ThemeMode['DARK'] = 'dark';
})(ThemeMode || (ThemeMode = {}));

export let MenuOrientation;

(function (MenuOrientation) {
  MenuOrientation['VERTICAL'] = 'vertical';
  MenuOrientation['HORIZONTAL'] = 'horizontal';
})(MenuOrientation || (MenuOrientation = {}));

export let ThemeDirection;

(function (ThemeDirection) {
  ThemeDirection['LTR'] = 'ltr';
  ThemeDirection['RTL'] = 'rtl';
})(ThemeDirection || (ThemeDirection = {}));

export let NavActionType;

(function (NavActionType) {
  NavActionType['FUNCTION'] = 'function';
  NavActionType['LINK'] = 'link';
})(NavActionType || (NavActionType = {}));

export let Gender;

(function (Gender) {
  Gender['MALE'] = 'Male';
  Gender['FEMALE'] = 'Female';
})(Gender || (Gender = {}));

export let DropzopType;

(function (DropzopType) {
  DropzopType['DEFAULT'] = 'default';
  DropzopType['STANDARD'] = 'standard';
})(DropzopType || (DropzopType = {}));
export let AuthProvider;

(function (AuthProvider) {
  AuthProvider['JWT'] = 'jwt';
  AuthProvider['FIREBASE'] = 'firebase';
  AuthProvider['AUTH0'] = 'auth0';
  AuthProvider['AWS'] = 'aws';
  AuthProvider['SUPABASE'] = 'supabase';
})(AuthProvider || (AuthProvider = {}));

export const APP_AUTH = AuthProvider.JWT;
export const SHOW_SUPERUSER_PREFERENCES = false;

// ==============================|| THEME CONFIG ||============================== //

const config = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'theme5',
  themeDirection: ThemeDirection.LTR,
  BASE_URL: window.location.origin, // DO NOT CHANGE THIS VALUE, change manually if needed and dont commit to git, this is used for production build
};

export default config;

export const MaritalStatus = {
  MARRIED: 'Married',
  UNMARRIED: 'Unmarried'
};
